import cx from 'classnames'
import { FC } from 'react'
import Styles from './Section.module.scss'
import { ReactComponent as ChevronDown } from 'assets/icons/chevronDown.svg'
import Collapse from 'react-css-collapse'
import { useDocStore } from 'stores/DocStore'
import { observer } from 'mobx-react-lite'
import { capitalize } from 'lodash'

interface SectionProps {
  label: string
  sectionKey: string
  className?: string
  showChevron?: boolean
}

export const Section: FC<React.PropsWithChildren<SectionProps>> = observer(
  ({ children, className, label, sectionKey, showChevron = true }) => {
    const docStore = useDocStore()
    const collapsed = docStore.rightRailStore.isSectionCollapsed(sectionKey)
    const toggleSection = () => {
      docStore.rightRailStore.toggleSection(sectionKey)
    }

    return (
      <div className={cx(Styles.section, className)} data-test-id={`right-rail-section-${sectionKey}`}>
        <div className={Styles.labelContainer} onClick={toggleSection}>
          <div className={Styles.label}>
            {capitalize(label)}
            {showChevron && <ChevronDown className={cx(Styles.chevron, { [Styles.rotate]: collapsed })} />}
          </div>
          <hr className={Styles.hr} />
        </div>

        <Collapse isOpen={!collapsed}>
          <div />
          <div className={Styles.children}>{children}</div>
        </Collapse>
      </div>
    )
  },
)
